<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content requestVoiceCont">
                        <el-form :model="formValue" ref="formValue" :rules="rules" label-width="100px" class="">

                            <el-row>
                                <el-col :span="8" :offset='1'>
                                    <el-form-item label="订单编号" prop="orderNumber">
                                        <el-input v-model="formValue.orderNumber" disabled placeholder="请输入订单编号">
                                        </el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <el-row>
                                <el-col :span="8" :offset='1'>
                                    <el-form-item label="退款原因" prop="refundReason">
                                        <el-input type="textarea" :rows="6" v-model="formValue.refundReason"
                                            placeholder="请输入退款原因"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <div class="signUpNowBtn blueGradient submitRequestRefund" @click="submitForm()">提交</div>
                        </el-form>

                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../common/commonHeader.vue"; //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件
export default {
    name: 'studentsNote',
    components: {
        commonheader,
        leftMenu,
        exit
    },


    data () {
        return {
            options: [
                {
                    value: '增值税电子普通发票',
                    label: '增值税电子普通发票'
                },


            ],

            formValue: {

            },
            value: '',

            rules: {
                orderNumber: [
                    { required: true, message: '请输入订单编号', trigger: 'blur' },
                    { pattern: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/, message: '订单号只能为数字' }
                ],
                refundReason: [
                    { required: true, message: '请输入退款原因', trigger: 'blur' },
                ],


            }

        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        this.$set(this.formValue,'orderNumber',this.$route.query.orderId);
    },
    methods: {
        submitForm () {
            this.$refs['formValue'].validate((valid) => {
                if (valid) {
                    this.submitRequestRefund(this.formValue)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },


        submitRequestRefund (formValue) {

            let submitRefundParams = {
                order_id: formValue.orderNumber,
                reason: formValue.refundReason
            }
            this.$store.dispatch('requestRefund', submitRefundParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.$message('申请退款提交成功，正在审核中，请耐心等待');
                        setTimeout(()=>{
                            this.$router.go(-1);
                        },2000)

                        // console.log('我的订单页面数据返回====', myOrdersParams, res)
                    } else {


                    }

                    //console.log(this.associationNewsListData)

                }).catch(error => {
                    console.log('catch====', error)
                })

        }












    },
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 0 86px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    .title
        margin 25px 0 19px
        font-size 20px
        color #0173FF
        border-left 2px solid #0173FF
        padding-left 10px
    p
        font-size 16px
        color #333
        line-height 30px
.signUpNowBtn
    height 42px
    line-height 42px
    text-align center
    color #fff
    width 290px
    margin 50px auto 0
    border-radius 4px
    cursor pointer
    letter-spacing 2px
.submitRequestInvoice
    margin-top 150px
.el-select
    width 242px
</style>
<style lang="stylus">
.requestVoiceCont input
    width 242px
.requestVoiceCont textarea
    resize none
</style>


// WEBPACK FOOTER //
// src/components/my/requestRefund.vue